import { render, staticRenderFns } from "./AccountSettingsForm.vue?vue&type=template&id=c4b3cacc&"
import script from "./AccountSettingsForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports